__turbopack_context__.v({
  "badge": "SAd9mW_badge",
  "badge-container": "SAd9mW_badge-container",
  "button": "SAd9mW_button",
  "clickable-container": "SAd9mW_clickable-container",
  "content-container": "SAd9mW_content-container",
  "pattern-background": "SAd9mW_pattern-background",
  "splash-card": "SAd9mW_splash-card",
  "splash-container": "SAd9mW_splash-container",
});
